(() => {
  if (window.frameSceneFooterReady) return;
  window.frameSceneFooterReady = true;
  const mobile = window.matchMedia('(max-width:749px)');
  const init = () => {
    document.querySelectorAll('[data-footer]').forEach(footer => {
      if (footer.dataset.ready) return;
      footer.dataset.ready = 'true';
      footer.querySelectorAll('.footer-toggle').forEach(button => {
        button.setAttribute('aria-expanded', String(!mobile.matches));
        button.addEventListener('click', () => {
          if (!mobile.matches) return;
          button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
        });
      });
    });
  };
  mobile.addEventListener('change', () => {
    document.querySelectorAll('[data-footer] .footer-toggle').forEach(button => {
      button.setAttribute('aria-expanded', String(!mobile.matches));
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
